import { MatcherFactory } from "../../../models/matchers/factory/MatcherFactory";
import { FuzzyFieldMatcher } from "../../../models/matchers/FuzzyFieldMatcher";
import { FuzzyInput } from "../../fuzzy/FuzzyInput";
import { FuzzyThreshold } from "../../fuzzy/FuzzyThreshold";
import { DlfMatcherLabel } from "../../inputGroup/DlfMatcherLabel";
import { DlfTypeLabel } from "../../inputGroup/DlfTypeLabel";
import { InputGroup } from "../../inputGroup/InputGroup";
import { Label, LabelProps } from "../../inputGroup/Label";
import { FieldMatcherEditorChildProps } from "../FieldMatcherEditor";

export { FuzzyFieldMatcherEditor, Props as FuzzyFieldMatcherEditorProps };

type Props = {
  matcher: FuzzyFieldMatcher;
  update: (matcher: FuzzyFieldMatcher) => void;
} & FieldMatcherEditorChildProps<FuzzyFieldMatcher>;

const FuzzyFieldMatcherEditor = (props: Props) => {
  return (
    <InputGroup
      className={"fieldMatcherEditor fuzzyDlfEditor"}
      button={props.button != undefined}
    >
      <DlfMatcherLabel label={"Fuzzy"} {...props} />

      <FuzzyInput
        initialValue={props.matcher.fuzzyKey}
        update={(result) => {
          props.matcher.fuzzyKey = result;
          props.update(props.matcher);
        }}
      />
      <FuzzyThreshold
        threshold={props.matcher.threshold}
        update={(threshold) => {
          props.matcher.threshold = threshold;
          props.update(props.matcher);
        }}
      />
      {props.button && props.button}
    </InputGroup>
  );
};
